var _defs, _g, _animateTransform;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinnerBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 200 200",
    color: "#3CC3E2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "spinner-secondHalf"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 0,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0.5,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spinner-firstHalf"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0.5,
    stopColor: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 19
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#spinner-secondHalf)",
    d: "M 10 100 A 90 90 0 0 1 190 100"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#spinner-firstHalf)",
    d: "M 190 100 A 90 90 0 0 1 10 100"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M 10 100 A 90 90 0 0 1 10 98"
  }))), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    from: "0 0 0",
    to: "360 0 0",
    attributeName: "transform",
    type: "rotate",
    repeatCount: "indefinite",
    dur: "1300ms"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerBlue);
export default __webpack_public_path__ + "static/media/spinner-blue.550750e2ecb049f5acd4fb29c4370dd5.svg";
export { ForwardRef as ReactComponent };